<div
    class="orb-app-light:bg-secondary left-0 z-[5] w-full bg-primary pt-0 dark:bg-contrast-black dark:text-contrast-yellow"
    [ngClass]="{
        'fixed h-screen': !env.IS_MOBILE_APP,
        'block overflow-y-auto': mobileMenuOpen,
        'bounce-behavior': env.DISABLE_BOUNCE_IOS_EFFECT,
        'container-mobile-menu fixed h-full': env.IS_MOBILE_APP
    }"
    [cdkTrapFocus]="trapFocus">
    <div class="menu-height m-auto mb-[var(--ion-safe-area-bottom)] flex min-h-full max-w-3xl flex-col">
        <output class="cdk-visually-hidden" aria-atomic="true">
            <ng-container *ngIf="hasContrastChanged">
                {{
                    (isContrast$ | async)
                        ? ('HIGH_CONTRAST_MODE_WAS_TURNED_OFF' | translate)
                        : ('HIGH_CONTRAST_MODE_WAS_TURNED_ON' | translate)
                }}
            </ng-container>
        </output>

        <div class="menu-container flex min-h-full flex-col justify-between">
            <div class="menu flex-column flex">
                <div class="relative flex items-center">
                    <div class="flex w-full items-center">
                        <button
                            class="orb-app-light:bg-white var-app-light:bg-white vl-app-light:bg-grey-white_smoke absolute left-6 top-8 flex h-6 w-6 items-center justify-center rounded-full bg-primary-text dark:bg-contrast-yellow"
                            *ngIf="!env.MOBILE_MENU_CUSTOMIZATION?.HIDE_ADDITIONAL_ACCESSIBILITY_BUTTON"
                            [attr.aria-label]="
                                (isContrast$ | async)
                                    ? ('TURN_OFF_HIGH_CONTRAST_MODE' | translate)
                                    : ('TURN_ON_HIGH_CONTRAST_MODE' | translate)
                            "
                            (click)="toggleContrast()"
                            (keydown.enter)="toggleContrast()"
                            (keydown.space)="toggleContrast()">
                            <ion-icon
                                class="orb-app-light:bg-white var-app-light:bg-white orb-app-light:text-[var(--color-secondary)] var-app-light:text-[var(--color-primary)] text-[1rem] text-primary dark:text-contrast-black"
                                name="accessibility"></ion-icon>
                        </button>
                    </div>
                </div>

                <div class="mt-12 p-4">
                    <h1
                        class="mt-4 pl-6 pr-6 text-center text-lg font-bold text-white dark:text-contrast-yellow"
                        *ngIf="!ridangoAuth.getLoginStatus()">
                        {{ 'MORE_MENU_LOGIN_TITLE' | translate }}
                    </h1>
                    <ul class="login-section flex flex-col items-center px-4">
                        <li
                            class="flex w-full items-center justify-center"
                            *ngIf="helperService.isAllowedPath('/login')">
                            <button
                                class="menu-login-button mt-6 h-14 w-full rounded-lg pb-4 pt-4 text-base font-bold text-black dark:bg-contrast-yellow dark:text-contrast-black"
                                *ngIf="!ridangoAuth.getLoginStatus()"
                                [ngClass]="{ 'contrast-button': isContrast }"
                                [routerLink]="'/login' | localize"
                                [queryParams]="{
                                    backButton:
                                        env.IS_MOBILE_APP && env.ONBOARDING?.BACK_BUTTON_LOGIN_AFTER_ONBOARDING
                                            ? true
                                            : null
                                }"
                                (click)="closeMobileMenu()">
                                <ion-label
                                    class="sr-app-light:text-white font-bold normal-case text-black dark:!text-contrast-black">
                                    {{ 'HEADER_SECONDARY_NAV_LOGIN' | translate }}
                                </ion-label>
                            </button>
                        </li>
                        <li
                            class="relative flex w-full items-center justify-center"
                            *ngIf="helperService.isAllowedPath('/register')">
                            <button
                                class="menu-login-button mt-6 h-14 w-full rounded-lg pb-4 pt-4 text-base font-bold text-black dark:bg-contrast-yellow dark:text-contrast-black"
                                *ngIf="!ridangoAuth.getLoginStatus()"
                                [ngClass]="{ 'contrast-button': isContrast }"
                                [routerLink]="'/register' | localize"
                                (click)="closeMobileMenu(false, { title: 'BTN_REGISTER' })">
                                <ion-label
                                    class="sr-app-light:text-white font-bold normal-case text-black dark:!text-contrast-black">
                                    {{ 'BTN_REGISTER' | translate }}
                                </ion-label>
                            </button>
                        </li>
                    </ul>
                    <div
                        class="flex flex-col items-center"
                        *ngIf="
                            ridangoAuth.getLoginStatus() && !env.MOBILE_MENU_CUSTOMIZATION?.SHOW_USER_PHOTO_PLACEHOLDER
                        ">
                        <div
                            [ngClass]="{
                                'solid-border flex h-[4.5rem] w-[4.5rem] items-center justify-center rounded-full border-[0.188rem] border-white dark:border-contrast-yellow':
                                    env?.MOBILE_MENU_CUSTOMIZATION?.ALTERNATIVE_USER_ICON
                            }"
                            aria-hidden="true">
                            <ion-icon
                                class="h-[3.313rem] w-[3.313rem] text-white dark:text-contrast-yellow"
                                [name]="'person-circle'"></ion-icon>
                        </div>
                        <a
                            class="vl-app-light-dark:max-w-full sr-app-light:max-w-full mt-4 overflow-hidden text-ellipsis whitespace-nowrap pl-3 pr-3 text-base font-bold text-white dark:text-contrast-yellow"
                            [routerLink]="'/account/profile' | localize"
                            (click)="closeMobileMenu()">
                            {{ (profile$ | async)?.name || (profile$ | async)?.email }}
                        </a>
                    </div>
                    <div
                        class="flex flex-col items-center"
                        *ngIf="
                            ridangoAuth.getLoginStatus() && env.MOBILE_MENU_CUSTOMIZATION?.SHOW_USER_PHOTO_PLACEHOLDER
                        ">
                        <div class="orb-app-light:text-white var-app-light:text-white h-16 w-16" aria-hidden="true">
                            <mat-icon svgIcon="user-placeholder-icon" icon> </mat-icon>
                        </div>
                        <p
                            class="orb-app-light:text-white var-app-light:text-white text-primary-text dark:text-contrast-yellow">
                            {{ ridangoAuth.getLoggedInUserName() || (profile$ | async)?.email }}
                        </p>
                    </div>
                </div>
                <ng-template #container></ng-template>
            </div>
            <div class="logo-logout-wrapper">
                <ng-container
                    *ngIf="!env?.MOBILE_MENU_CUSTOMIZATION?.ALTERNATIVE_FOOTER; else alternativeMenuFooter"
                    [ngTemplateOutlet]="defaultMenuFooter"></ng-container>
                <ng-container [ngTemplateOutlet]="logoutButton"></ng-container>
            </div>
        </div>
    </div>
</div>

<ng-template #alternativeMenuFooter>
    <div class="menu-footer flex-column bottom-14 flex w-full flex-1 bg-transparent pb-14 pt-8">
        <div class="flex justify-center bg-transparent px-8 py-4" aria-hidden="true">
            <ion-icon
                class="vl-app-light-dark:h-[4rem] vl-app-light:text-[#4E8FA1] vl-app-dark:text-contrast-black h-full max-h-28 w-full"
                aria-hidden="true"
                src="{{ assetsPath$ | async }}/img/logo.svg"></ion-icon>
        </div>
        <div
            class="-mt-px flex w-full justify-center dark:bg-contrast-black"
            *ngIf="helperService.isAllowedPath('/login')">
            <button
                class="h-12 w-full border-0 bg-primary pl-3 pr-3 text-sm font-bold text-white dark:bg-contrast-black dark:text-contrast-yellow"
                *ngIf="ridangoAuth.getLoginStatus()"
                (click)="logout()"
                (keydown.enter)="logout()">
                {{ 'MAIN_MENU_LOGOUT' | translate }}
            </button>
        </div>
    </div>
</ng-template>

<ng-template #defaultMenuFooter>
    <div
        class="menu-footer orb-app-light:bg-secondary var-app-light:bg-primary flex-column bottom-14 flex w-full max-w-3xl bg-primary-footer dark:bg-contrast-black">
        <div class="orb-app-light:bg-secondary -mt-px w-full flex-1 bg-primary dark:bg-contrast-black"></div>
        <div
            class="var-app-light:border-top-color-secondary menu-footer__top dark:black-triangle m-auto -mt-px h-0 w-0 overflow-hidden"></div>
        <div
            class="orb-app-light-dark:justify-center orb-app-light-dark:text-white var-app-light-dark:justify-center var-app-light:text-white flex flex-col justify-end px-2">
            <ion-icon
                class="mb-2 h-12 max-h-28 w-full"
                src="{{ assetsPath$ | async }}/img/{{
                    env?.MOBILE_MENU_CUSTOMIZATION?.ALTERNATIVE_LOGO ? 'mobileMenuLogo.svg' : 'splashScreenLogo.svg'
                }}"></ion-icon>
            <ul
                class="-mt-px flex w-full justify-center dark:bg-contrast-black"
                *ngIf="
                    helperService.isAllowedPath('/login') && env?.MOBILE_MENU_CUSTOMIZATION?.SHOW_LOGOUT_UNDER_APP_LOGO
                ">
                <li>
                    <button
                        class="orb-app-light:bg-secondary orb-app-light-dark:text-white var-app-light:bg-primary var-app-light:text-[var(--color-secondary)] mb-8 flex w-full items-center justify-center gap-1 border-0 bg-primary pl-3 text-sm font-bold text-primary-text dark:bg-contrast-black dark:text-contrast-yellow"
                        *ngIf="ridangoAuth.getLoginStatus()"
                        [attr.aria-label]="'MAIN_MENU_LOGOUT' | translate"
                        (click)="logout()"
                        (keydown.enter)="logout()">
                        <span>
                            {{ 'MAIN_MENU_LOGOUT' | translate }}
                        </span>
                        <span
                            class="material-icons text-[0.8125rem]"
                            *ngIf="env?.MOBILE_MENU_CUSTOMIZATION?.SHOW_LOGOUT_TEXT_ARROW">
                            arrow_forward
                        </span>
                    </button>
                </li>
            </ul>
        </div>
    </div>
</ng-template>

<ng-template #logoutButton>
    <div
        class="-mt-px flex w-full justify-center dark:bg-contrast-black"
        *ngIf="
            helperService.isAllowedPath('/login') &&
            !env?.MOBILE_MENU_CUSTOMIZATION?.SHOW_LOGOUT_UNDER_APP_LOGO &&
            !env?.MOBILE_MENU_CUSTOMIZATION?.ALTERNATIVE_FOOTER
        ">
        <button
            class="orb-app-light:bg-secondary orb-app-light-dark:text-white var-app-light:bg-primary var-app-light-dark:text-white h-12 w-full border-0 bg-primary pl-3 text-sm font-bold text-primary-text dark:bg-contrast-black dark:text-contrast-yellow"
            *ngIf="ridangoAuth.getLoginStatus()"
            (click)="logout()"
            (keydown.enter)="logout()">
            {{ 'MAIN_MENU_LOGOUT' | translate }}
        </button>
    </div>
</ng-template>
